<div class="container-fluid relative">
    <div class="grid grid-cols-1">
        <div class="md:px-10 py-10 px-4">

            <div class="title-heading text-center">
                <img src="assets/images/error.png" class="mx-auto" alt="">
                <h1 class="mt-3 mb-6 md:text-4xl text-3xl font-bold">Pagina niet gevonden</h1>
                <p class="text-slate-400">Oeps, daar ging iets verkeerd. <br> Deze pagina bestaat niet.</p>

                <div class="mt-4">
                    <a href="index.html" class="btn bg-emerald-600 hover:bg-emerald-700 border-emerald-600 hover:border-emerald-700 text-white rounded-md">Terug naar Home</a>
                </div>
            </div>

        </div>
    </div><!--end grid-->
</div><!--end container-->
